export default __webpack_public_path__ + "static/media/lifesyle.f5eed866.png";